import { ReactElement } from 'react';

import { Skeleton, Card } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

import { useWindowWidth } from ':hooks';

// easier to draw
const ARRAY_SKELETON = [1, 2];

export function UserInfoSkeleton(): ReactElement {
  const windowWidth = useWindowWidth();

  return (
    <Card border='default'>
      <div className={styles.wrapper}>
        <div className={styles.info}>
          <Skeleton className={styles.avatar} radius={12} variant='square' />
          <div className={styles.wrap}>
            <Skeleton className={styles.name} variant='title' radius={12} />
            <div className={styles.surnamePatronymic}>
              <Skeleton
                variant='title'
                radius={12}
                className={styles.surname}
              />
              <Skeleton radius={12} className={styles.patronymic} />
            </div>
            <Skeleton className={styles.post} radius={12} />
          </div>
        </div>
        {windowWidth > 959 && (
          <>
            <div className={styles.otherData}>
              {ARRAY_SKELETON.map(el => {
                return (
                  <div key={el} className={styles.col}>
                    <Skeleton
                      className={styles.icon}
                      radius={12}
                      variant='square'
                    />
                    <div>
                      <Skeleton className={styles.title} radius={12} />
                      <Skeleton className={styles.value} radius={12} />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={styles.contacts}>
              {ARRAY_SKELETON.map(el => {
                return (
                  <div key={el} className={styles.col}>
                    <Skeleton
                      className={styles.icon}
                      radius={12}
                      variant='square'
                    />
                    <div>
                      <Skeleton className={styles.contactsTitle} radius={12} />
                      <Skeleton className={styles.contactsValue} radius={12} />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
